// removed by extract-text-webpack-plugin
module.exports = {"ui":"form_ui_b59a2t"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/form/form.scss
// module id = 525
// module chunks = 0